import { render } from "./OpeningHoursRegularInput.vue?vue&type=template&id=59cba003"
import script from "./OpeningHoursRegularInput.vue?vue&type=script&lang=js"
export * from "./OpeningHoursRegularInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__